import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import ProjectCardFactory from "../ProjectCardFactory";
import classes from "./classes.module.scss";

type IProps = {
	projects: ProjectResponseResource[];
};

export default function ProjectGrid(props: IProps) {
	return (
		<div className={classes["root"]}>
			{props.projects.map((project) => (
				<ProjectCardFactory key={project.id} project={project} />
			))}
		</div>
	);
}
